import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ApolloQueryResult } from '@apollo/client';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import {
  CreditLineCard,
  HealthCheckCard,
  DocumentsCard,
  TasksCard,
  VendorOpportunity,
} from 'modules/vendorOpportunity';

interface Props {
  creditApp: any;
  userName: string;
  accountId: string;
  vendorProfile: any;
  vo: VendorOpportunity;
  creditAppRefetch: () => Promise<ApolloQueryResult<void>>;
  permissions: Record<'creditLine' | 'healthCheck' | 'docs' | 'tasks', boolean>;
}

export const CreditLineTab = ({
  vo,
  userName,
  accountId,
  creditApp,
  permissions,
  vendorProfile,
  creditAppRefetch,
}: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.creditLineTab}>
      <RenderWithCondition condition={permissions.creditLine}>
        <CreditLineCard
          userName={userName}
          creditLineRequestLegacyData={{
            notes: vo?.creditLineNotes,
            status: vo?.creditLineStatus as any,
            VOAmount: vo?.creditLineAmountRequested ?? 0,
            creditAppAmount: creditApp?.creditLineAmountRequested ?? 0,
          }}
          VOId={vo?.vendorOpportunityId}
          isCreditLineRequested={vo.creditLineRequest?.length > 0 || creditApp.applyingFor.includes('creditLine')}
          expirationDate={creditApp?.creditLineExpirationDate ?? null}
          creditLineRequest={vo?.creditLineRequest?.[vo?.creditLineRequest.length - 1] || null}
        />
      </RenderWithCondition>

      <RenderWithCondition condition={permissions.healthCheck}>
        <HealthCheckCard
          userName={userName}
          creditApp={creditApp}
          cardTitle="Compliance"
          accountId={accountId}
          refetchCreditApp={creditAppRefetch}
          softPullInDealerPortal={vendorProfile.softPullInDealerPortal}
        />
      </RenderWithCondition>

      <RenderWithCondition condition={permissions.docs}>
        <DocumentsCard VOId={vo.vendorOpportunityId} />
      </RenderWithCondition>

      <RenderWithCondition condition={permissions.tasks}>
        <TasksCard VOId={vo.vendorOpportunityId} />
      </RenderWithCondition>
    </Box>
  );
};

const useStyles = makeStyles({
  creditLineTab: {
    gap: '1rem',
    display: 'flex',
    flexDirection: 'column',
  },
});
